var _path, _path2, _ellipse, _circle, _path3, _ellipse2, _circle2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNormalPack6 = function SvgNormalPack6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.881 70.888c55.284 13.621 40.395 54.417 26.04 73.112 16.024 21.633-1.336 35.721-12.019 40.062-9.614 53.681-52.747 43.733-73.111 32.048-28.844 4.808-42.064-14.689-45.07-25.038-36.855-6.41-36.722-37.39-32.048-52.079-25.64-42.465 10.683-63.097 32.049-68.105 13.62-37.657 45.736-24.37 60.092-13.02 20.831-14.422 38.058 2.671 44.067 13.02Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.544 171.989c13.146-.001 40.38-.12 62.818-.12",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.257,
    cy: 121.971,
    rx: 22.12,
    ry: 29.493,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.258,
    cy: 121.972,
    r: 7.373,
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.273 117.226h44.241",
    stroke: "#000",
    strokeWidth: 6.267,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.399,
    cy: 121.971,
    rx: 22.12,
    ry: 29.493,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.399,
    cy: 121.972,
    r: 7.373,
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.415 117.226h44.24",
    stroke: "#000",
    strokeWidth: 6.267,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.55 139.97c3.74 14.961 14.025 44.32 25.245 42.076 11.221-2.244 12.156-27.115 11.221-39.271m0 0c1.87 1.87 7.573 5.049 15.428 2.805m-15.428-2.805c2.805 3.74 9.818 10.659 15.428 8.415m-15.428-8.415c2.337.468 8.415.561 14.025-2.805M63.894 149.788c-3.74 14.96-14.026 44.32-25.246 42.076-11.22-2.244-12.155-27.116-11.22-39.271m0 0c-1.87 1.87-7.574 5.049-15.428 2.805m15.428-2.805c-2.805 3.74-9.818 10.659-15.428 8.415m15.428-8.415c-2.338.467-8.415.561-14.026-2.805",
    stroke: "#000",
    strokeWidth: 1.964,
    strokeLinecap: "round"
  })));
};
export default SvgNormalPack6;